import {EValidationTestType} from "../../../utils/validationConfigs";

export const formConfig = {
    register: {
        registerSmsCode: {
            model: "register",
            name: "registerSmsCode",
            standardMessage: undefined,
            validationTests: [
                EValidationTestType.hasValue,
                EValidationTestType.isPin
            ],
            visible: true,
            showSuccess: true,
        },
    },
};
